import * as THREE from 'three';

class Segment {
	constructor(sliceA, sliceB, indexVerticesA, indexVerticesB, geometry) {
		//const isFirstSegment = geometry.vertices.length === 0;

		/*
		if (isFirstSegment) {
			geometry.vertices.push(
				...sliceA.vertices.map(v => {
					return new THREE.Vector3(v.x, v.y, v.z);
				})
			);
		}

		const vI = geometry.vertices.length - 6;

		geometry.vertices.push(
			...sliceB.vertices.map(v => {
				return new THREE.Vector3(v.x, v.y, v.z);
			})
		);
		*/

		const vI = [];
		let n;
		for (n = 0; n < 6; n++) {
			vI.push(indexVerticesA * 6 + n);
		}
		for (n = 0; n < 6; n++) {
			vI.push(indexVerticesB * 6 + n);
		}

		var normal = new THREE.Vector3(0, 0, 0); //optional
		var color = new THREE.Color(0xffaa00); //optional
		var materialIndex = 0; //optional

		let j;
		for (j = 0; j < 5; j++) {
			geometry.faces.push(new THREE.Face3(vI[j], vI[j + 1], vI[j + 6], normal, color, materialIndex));
			geometry.faces.push(new THREE.Face3(vI[j + 1], vI[j + 7], vI[j + 6], normal, color, materialIndex));
		}

		geometry.faces.push(new THREE.Face3(vI[5], vI[0], vI[11], normal, color, materialIndex));
		geometry.faces.push(new THREE.Face3(vI[0], vI[6], vI[11], normal, color, materialIndex));
	}

	update = (i, curve, geometry) => {};
}

export default Segment;



// WEBPACK FOOTER //
// ./src/threejs/sculpture/Segment.js